import { h } from "preact";
export const SearchIcon = () => {
  return (
    <svg class="modal__toggle-open icon icon-search"  aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g href="#icon-search" id="Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.85168 14.8576C11.6358 14.8576 14.7034 11.7555 14.7034 7.92879C14.7034 4.10212 11.6358 1 7.85168 1C4.0676 1 1 4.10212 1 7.92879C1 11.7555 4.0676 14.8576 7.85168 14.8576Z" stroke="currentColor" stroke-width="1.2"/>
        <path d="M12.6875 12.8198L16.7179 16.8956" stroke="currentColor" stroke-width="1.2"/>
      </g>
    </svg>
  );
};
